import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=453ecbea&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/register.css?vue&type=style&index=0&id=453ecbea&scoped=true&lang=css&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=453ecbea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ecbea",
  null
  
)

export default component.exports